import { safeDefine } from "../../registration/safe-define.js";
import { MinimalVideoSkinElement } from "../../presets/video/minimal-skin.js";
import "../../internal/skins/minimal-video/register.js";
//#region src/define/video/minimal-skin.ts
safeDefine(MinimalVideoSkinElement);
//#endregion

//# sourceMappingURL=minimal-skin.js.map